import Vue from './vue-config'
import articleFilters from './components/articleFilters'

if (document.getElementById('articles')) {
    new Vue({
        el: '#articles',
        components: {
            articleFilters
        },
        data: {
            nodeId: 0,
            categories: [],
            query: '',
            catId: 0,
            typeId: 0,
            page: 0,
            perPage: 6,
            results: [],
        },
        computed: {
            displayPage() {
                return this.page + 1
            },
            pages() {
                return Math.ceil(this.results.length / this.perPage)
            },
            curPage() {
                return this.results.slice(this.page * this.perPage, (this.page * this.perPage) + this.perPage)
            },
            isSearch() {
                return this.query != '' || this.catId > 0
            }
        },
        methods: {
            setPage(p) {
                this.page = p
                this.doScroll()
            },
            filterChanged(model) {
                this.query = model.query
                this.catId = model.catId
                this.typeId = model.typeId
                this.page = 0
                this.doSearch()
            },
            doScroll() {
                var vm = this
                window.scrollTo({
                    top: vm.scrollTop,
                    behavior: 'smooth'
                })
            },
            doSearch() {
                var vm = this
                vm.doPost('/umbraco/surface/article/search', { catId: vm.catId, typeId: vm.typeId, query: vm.query, pinnedIds: vm.pinned, page: vm.page, perpage: 9 }, (data) => {
                    vm.results = data
                })
            },
        },
        updated() {
            window.lazyLoad.update()
        },
        mounted() {
            this.scrollTop = this.$el.querySelector('.news_solo').offsetTop - 30
            this.doSearch()
        }
    })
}